import { greyColors } from '@common/theme/colours';
import styled from 'styled-components';

export const GREY_60 = 'grey60';

export const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
    display: inline-block;
    max-width: 100%;
    font-size: '16px';
    line-height: 20px;
    & > span {
      margin-top: 2px;
      max-width: calc(100% - 30px);
    }
  }

  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: top;
    width: 20px;
    height: 20px;
    background: white;
    border: ${({ theme }) => `1px solid ${theme.primaryColour}`};
    border-radius: ${({ theme }) => theme.inputRadius};
    transition: ${({ theme }) => `all ${theme.transitionType} ${theme.transitionTime}`};
  }

  &:hover + label:before {
    border-color: ${({ theme }) => theme.primaryColour};
  }

  &:checked + label:before {
    background: ${({ theme }) => theme.primaryColour};
    border-color: ${({ theme }) => theme.primaryColour};
  }

  &:disabled + label {
    cursor: auto;
  }

  &:disabled + label:before {
    box-shadow: none;
    opacity: 0.5;
  }

  &:checked + label:after {
    content: '';
    position: absolute;
    left: 7px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const HelperText = styled.p`
  font-size: 0.8rem;
  color: ${greyColors[GREY_60]};
  margin: 10px 0 0 30px;
`;
